export default {
  title: {
    id: 'buyback_swap_server_error_title',
    defaultMessage: 'Woops, server is not responding!',
  },
  content: {
    id: 'buyback_swap_server_error_content',
    defaultMessage: 'Please try again in 5 minutes...',
  },
}
